import { render, staticRenderFns } from "./NcsiNo1.vue?vue&type=template&id=65a22461&scoped=true"
import script from "./NcsiNo1.vue?vue&type=script&lang=js"
export * from "./NcsiNo1.vue?vue&type=script&lang=js"
import style0 from "./NcsiNo1.vue?vue&type=style&index=0&id=65a22461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a22461",
  null
  
)

export default component.exports